export default __webpack_public_path__ + "static/media/mobilerepair.d1bfe77a.jpg";